import React from 'react';

export default ({children, path, alt, link, linkTitle, categoria, didascalia}) => {

    const getLabel = (categoria) => {
        if(typeof window !== "undefined"){
            return  ['galleria_foto', "galleria_flickr"].includes(categoria.toLowerCase()) ? (window.location.pathname.split("/")[1] === 'it' ? 'Foto' : 'Photo') : 'Video'
        }
    }

    return (<article className="card-wrapper">
        <div className="card card-img">
            <div className="img-responsive-wrapper">
                <div className="img-responsive">
                    {categoria?.toLowerCase() === 'video' ?
                        <embed className="embed-responsive-item"
                               src={path}
                               title={linkTitle}/> :

                        <figure className="img-wrapper">
                            <figcaption className="sr-only">{didascalia}</figcaption>
                            {linkTitle && link ?
                                <a href={link} title={linkTitle}>
                                    <img src={path} alt={alt}/>
                                </a>
                                : <img src={path} alt={alt}/>
                            }

                        </figure>}
                </div>
            </div>
            <div className="card-body">
                {categoria ? (
                    <div className="category-top">
                        <span className="category">{getLabel(categoria)}</span>
                    </div>
                ) : null}
                <h4 className="card-title"><a href={link} title={linkTitle}>{linkTitle}</a></h4>
            </div>
        </div>
    </article>)
}
